import React from 'react'

export default function CardLexi () {
    return<>
    {/*    HEADER IMAGE */}
    <div className="flex flex-col items-center w-full aspect-video bg-[url('./images/LexisWorldBanner.png')] bg-cover bg-center" />
        <div className="text-left p-8">
            <span className={`font-semibold`}>Lexi's World</span> is a game to help kids to discover letters and words. There is a custom keyboard that only allows them to make words that are in the game. Type BUNNY and a cute bunny will appear. Type CARROT to feed it.</div>
    </>
}